// extracted by mini-css-extract-plugin
export default {"FullscreenCarousel":"FullscreenDesktopHighlights_FullscreenCarousel__XnUea"};